import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import DashboardPage from "./pages/DashboardPage";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AssistantPage from "./pages/AssistantPage";
import FounderCockpit from "./pages/FounderCockpit";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="text-[#DC143C] font-heading text-2xl uppercase tracking-widest animate-pulse">
          INITIALIZING SELENA MATRIX...
        </div>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {

  const pingDncmCore = async () => {
    try {
      const res = await fetch("/api/entry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "healthcheck",
          source: "dncm-float-button"
        })
      });
      const data = await res.json();
      console.log("DNCM CORE:", data);
      alert("PING DNCM CORE envoyé");
    } catch (err) {
      console.error(err);
      alert("Erreur ping DNCM CORE");
    }
  };

  return (
    <AuthProvider>
      <div className="App">
        <div className="scanlines" />
        <BrowserRouter>
          <Routes>
            <Route path="/cockpit" element={<FounderCockpit />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route 
              path="/assistant" 
              element={
                <ProtectedRoute>
                  <AssistantPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/*" 
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </BrowserRouter>

        <Toaster 
          position="top-right"
          toastOptions={{
            style: {
              background: '#0A0A0A',
              border: '1px solid #DC143C',
              color: '#EDEDED',
              fontFamily: 'JetBrains Mono, monospace',
            },
          }}
        />


      </div>
    </AuthProvider>
  );
}

export default App;
